export const checkCookiesTooLarge = function () {
    if (document.cookie == null || document.cookie.length === 0) return;

    // we don't need these cookies anymore
    window.eraseCookie('favProposalIds');
    window.eraseCookie('favTeacherIds');
    window.eraseCookie('favSchoolIds');
    window.eraseCookie('favChallengeIds');
    window.eraseCookie('favSearchURLs');
    window.eraseCookie('myGPs');

    let maxCookieSize = 10240;
    const extraCookieCharacters = 65;

    const ca = document.cookie.split(';');
    const numCookies = ca.length;
    // document.cookie string doesn't include path or expiration date
    maxCookieSize = maxCookieSize - (extraCookieCharacters * numCookies);

    let overMaxCookieSize = false;
    if (document.cookie.length > maxCookieSize) {
        overMaxCookieSize = true;
    }

    // log cookies
    if (overMaxCookieSize) {
        const allCookies = document.cookie;
        const trimmedCookies = [];

        const remainingCookieSizes = [];
        for (let i = 0; i < numCookies; i++) {
            const c = trim(ca[i]);
            const cName = c.split('=')[0];
            remainingCookieSizes.push([cName, ca[i].length]);
        }

        // remove largest cookies first, skipping amazon cookie
        const doNotRemove = ['amazon_Login_state_cache', 'userId', 'amazon-pay-connectedAuth'];
        remainingCookieSizes.sort(function (a, b) { return (b[1] - a[1]); });
        for (let i = 0; i < remainingCookieSizes.length; i++) {
            const cookieName = remainingCookieSizes[i][0];
            if (document.cookie.length > maxCookieSize && !doNotRemove.includes(cookieName)) {
                trimmedCookies.push(cookieName);
                window.eraseCookie(cookieName);
            }
        }

        $.post(secureBaseURL + 'common/cookies-too-large.html', { userId, allCookies, trimmedCookies: trimmedCookies.join() });
        console.log('cookies have been removed.');
    }
};
